/**
 * API 엔드포인트 상수 (GUEST_REVIEW_API.md 2026-04-20 기반)
 *
 * [마이그레이션 방법]
 * 1. 신규 REST 경로가 확정되면 아래 TODO 주석을 실제 경로로 교체
 * 2. 해당 store 액션에서 legacyClient → client 로 전환
 * 3. 모든 마이그레이션 완료 후 legacyClient / src/common/API.js 제거
 *
 * [기존 cmd/func 매핑 - 참고용]
 * cmd: sc-util   → INIT (GET_SITE_NAME, GET_SITE_ID)
 * cmd: sc-review → INIT (GET_CUSTOM_ITEMS), REVIEW (SET_CHECKOUT)
 * cmd: sc-ad     → FINISH (GET_AD)
 * 이미지 업로드  → REVIEW (IMAGE_UPLOAD) — octet-stream, query params 방식
 */

export const ENDPOINTS = {

  // ── 앱 초기화 ────────────────────────────────────────────
  INIT: {
    GET_SITE_NAME: '',    // 기존: cmd: sc-util    / func: get-site-name-by-ota
    GET_SITE_ID: '',      // 기존: cmd: sc-util    / func: get-siteid-by-ota
    GET_CUSTOM_ITEMS: '',   // 기존: cmd: sc-review  / func: get-review-custom-items
    CUSTOM_ITEM_LIST: '/v1/staylab/custom-item',   // 신규: GET ?siteid=
    CUSTOM_ITEM_DETAIL: '/v1/staylab/custom-item'  // 신규: GET /{itemKey}?siteid=
  },

  // ── 리뷰 작성 ────────────────────────────────────────────
  REVIEW: {
    IMAGE_UPLOAD: '/v1/staylab/review/image/upload',  // 신규: POST ?siteid=&id=&file=, Content-Type: application/octet-stream
    SET_CHECKOUT: '/v1/staylab/review' // 기존: cmd: sc-review  / func: set-checkout
  },

  // ── 완료 ─────────────────────────────────────────────────
  FINISH: {
    GET_AD: ''  // 기존: cmd: sc-ad / func: review-ad
  }
}
